let zeroTrust = {
    title: "Zero Trust Office",
    downFTSafe:"Download FT SafeLogin Client",
    nowDownLoad:"Download now and start a borderless secure office trip",
    windows:"Windows Client",
    clickDown:"Click to download",
    MacDown:"Mac client",
    comming:"Coming soon",
    androidDown:"Android client",
    codeDown:"Scan code to download",
    iosDownload:"IOS client",
    codeDown2:"Scan code to download",
    editionNum:"Version No.: 3.14.7.423",
    clientDown:"Client Download",
    baseOnOwnSystem:"Choose to download and install the client based on your own system",
    accountLogin:"Account login",
    IAMquickly:"Connect with IAM and use the portal account authentication system to quickly log in",
    zeroTrust:"Zero Trust Office",
    neiwaiNet:"Connecting internal and external networks enables secure access to the company's intranet even when working from home or on the move",
    unifiedPortal:"Unified Portal",
    unifiedEnter:"Unified business resource access portal, allowing clients to directly access resources",
    dataSecurity:"Data security",
    yeWuYinShen:"Business stealth, shrinking exposure, reducing attacks, and making resources more secure",
  }
export default zeroTrust